import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/Tooltip"
import { openProductQuickView } from "@/components/productQuickView/store"
import type { MentionNames } from "../types"

const MENTION = /(#\d+)/g

// A note with every #product id turned into a link that opens the product
// quick view. The link shows the product's short name, or its full name cut
// to one line when it has none. The tooltip always shows the full name.
export default function NoteText({ note, names }: { note: string; names: MentionNames }) {
  return (
    <>
      {note.split(MENTION).map((part, i) => {
        const id = part.startsWith("#") ? part.slice(1) : null
        const product = id ? names[id] : null
        if (!id || !product) return <span key={i}>{part}</span>
        return (
          <Tooltip key={i}>
            <TooltipTrigger asChild>
              <span
                role="link"
                tabIndex={0}
                onClick={() => openProductQuickView(id)}
                onKeyDown={(e) => e.key === "Enter" && openProductQuickView(id)}
                className="inline-block max-w-64 cursor-pointer truncate align-bottom font-medium text-primary underline decoration-primary/40 underline-offset-2"
              >
                {product.short_name ?? product.name}
              </span>
            </TooltipTrigger>
            <TooltipContent>{product.name}</TooltipContent>
          </Tooltip>
        )
      })}
    </>
  )
}
